var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHelpFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-24_help_filled"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 204",
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#F9994C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "?",
    d: "M10.6641 14.1016C10.6719 12.1562 11.1953 11.5625 12.1328 10.9766C12.8047 10.5391 13.3281 10.0547 13.3203 9.33594C13.3281 8.55469 12.7188 8.04688 11.9609 8.03906C11.2872 8.04631 10.6538 8.46329 10.5403 9.25263C10.525 9.35933 10.438 9.44531 10.3302 9.44531H8.50828C8.39643 9.44531 8.30579 9.35349 8.31304 9.24188C8.44666 7.1848 10.0394 6.19531 11.9766 6.19531C14.1562 6.19531 15.6953 7.32812 15.6953 9.25781C15.6953 10.5469 15.0312 11.3594 14.0078 11.9766C13.125 12.5 12.7344 13.0078 12.7266 14.1016C12.7266 14.1965 12.6496 14.2734 12.5547 14.2734H10.8359C10.741 14.2734 10.6641 14.1965 10.6641 14.1016ZM10.4297 16.4922C10.4141 15.7734 11.0078 15.1875 11.7422 15.1953C12.4375 15.1875 13.0391 15.7734 13.0391 16.4922C13.0391 17.2188 12.4375 17.8047 11.7422 17.8047C11.0078 17.8047 10.4141 17.2188 10.4297 16.4922Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpFilled);
export default __webpack_public_path__ + "static/media/icon_help_filled.305c7d3bf03d1c549e8ed5dfc943cacd.svg";
export { ForwardRef as ReactComponent };